import { FiscalYear, FiscalYearFormData } from '../../types/fiscalYear';
import { useOrgApiClient } from '../../util/orgApiClient';
import { fiscalYearEndpoints } from '../endpoints/fiscalYears';

export function useFiscalYearService() {
  const { orgFetch, selectedOrg } = useOrgApiClient();

  const getFiscalYears = async () => {
    if (!selectedOrg) {
      throw new Error('No organization selected');
    }

    const response = await orgFetch<FiscalYear[]>(
      fiscalYearEndpoints.LIST(selectedOrg.id),
      {
        method: 'GET',
      },
    );
    return response.data;
  };

  const getFiscalYear = async (fyId: string) => {
    if (!selectedOrg) {
      throw new Error('No organization selected');
    }

    const response = await orgFetch<FiscalYear>(
      fiscalYearEndpoints.DETAIL(selectedOrg.id, fyId),
      {
        method: 'GET',
      },
    );
    return response.data;
  };

  const createFiscalYear = async (data: FiscalYearFormData) => {
    if (!selectedOrg) {
      throw new Error('No organization selected');
    }

    const response = await orgFetch<FiscalYear>(
      fiscalYearEndpoints.CREATE(selectedOrg.id),
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
    );
    return response.data;
  };

  const updateFiscalYear = async (fyId: string, data: FiscalYearFormData) => {
    if (!selectedOrg) {
      throw new Error('No organization selected');
    }

    const response = await orgFetch<FiscalYear>(
      fiscalYearEndpoints.UPDATE(selectedOrg.id, fyId),
      {
        method: 'PUT',
        body: JSON.stringify(data),
      },
    );
    return response.data;
  };

  const deleteFiscalYear = async (fyId: string) => {
    if (!selectedOrg) {
      throw new Error('No organization selected');
    }

    await orgFetch(fiscalYearEndpoints.DELETE(selectedOrg.id, fyId), {
      method: 'DELETE',
    });
  };

  const setActiveFiscalYear = async (fyId: string) => {
    if (!selectedOrg) {
      throw new Error('No organization selected');
    }

    const response = await orgFetch<{ success: string }>(
      fiscalYearEndpoints.SET_ACTIVE(selectedOrg.id, fyId),
      {
        method: 'POST',
      },
    );
    return response.data;
  };

  return {
    getFiscalYears,
    getFiscalYear,
    createFiscalYear,
    updateFiscalYear,
    deleteFiscalYear,
    setActiveFiscalYear,
  };
}
